var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.tituloEventos } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("Buscador", {
                                    attrs: {
                                      filter:
                                        _vm.gridApiZonasEventos &&
                                        _vm.gridApiZonasEventos.setQuickFilter.bind(
                                          _vm.gridApiZonasEventos
                                        )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("AsociacionGrid", {
                                    attrs: {
                                      "grid-options": _vm.gridOptionsZonasRutas,
                                      esEditar: true,
                                      headerCheckbox: true
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }